import { Button } from '@eventbrite/eds-button';
import React, { Component } from 'react';
import { OficceInfoType } from '../../../types';
import Navbar from '../navbar/Navbar';
import './OfficeInfo.scss';

export interface OfficeInfoStructureData {
    infoOffice: OficceInfoType;
}

class OfficeInfo extends Component<OfficeInfoStructureData> {
    render() {
        const {
            infoOffice: {
                location,
                location_title,
                location_address,
                direction_url,
            },
        } = this.props;

        return (
            <div
                className={`landing-locations about-contact location-${location} eds-align--center`}
            >
                <Navbar />
                <div className="landing-locations__title eds-align--center eds-l-mar-bot-20">
                    <h1 className="eds-text-hxl eds-text--center eds-text-weight--light eds-text-color--white eds-l-mar-bot-2">
                        {location_title}
                    </h1>
                    <h2 className="eds-text-hs eds-text--center eds-text-weight--light eds-text-color--white eds-l-mar-bot-2">
                        {location_address}
                    </h2>
                    {direction_url && (
                        <Button
                            style="link"
                            type="link"
                            rel="noopener noreferrer"
                            href={direction_url}
                            target="_blank"
                        >
                            Get Directions
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

export default OfficeInfo;
